import TCalendar from './calendar.vue'

TCalendar.install = Vue => {
  Vue.component(TCalendar.name, TCalendar)
}

export default TCalendar



// WEBPACK FOOTER //
// ./src/module/calendar/index.js